// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"264":"816bcfd5","282":"d0b261ab","303":"88e61584","358":"3061fca5","563":"1d37b96b","584":"745d4fdb","765":"b69eedd6","944":"0cf8adfc"}[chunkId] + ".chunk.css";
};